import { MINIMIZED_MODAL_KEY } from '../../../Modal'
import { clearWizardUuid, saveWizardUuid } from '../../RequestWizardForm'
import { useRequestDraft } from '../useRequestDraft'
import { useRequestWizardDraft } from '../useRequestWizardDraft'

// Picks the active draft slot (regular vs wizard) and returns the wizard-aware
// side-effect callbacks shared by every Request creation surface.
// `handleCreateNew` and `handleOpenDraft` plug straight into
// `useDraftCreationOpener`.
export function useRequestWizardDraftSession({ isWizardEnabled }) {
  const {
    draft: regularDraft,
    draftId: regularDraftId,
    setDraft: setRegularDraft,
  } = useRequestDraft()
  const {
    draft: wizardDraft,
    draftId: wizardDraftId,
    setDraft: setWizardDraft,
  } = useRequestWizardDraft()

  const draft = isWizardEnabled ? wizardDraft : regularDraft
  const draftId = isWizardEnabled ? wizardDraftId : regularDraftId
  const setDraft = isWizardEnabled ? setWizardDraft : setRegularDraft

  function handleCreateNew() {
    setDraft(null, 0)

    if (isWizardEnabled) {
      // Don't let the wizard auto-restore a stale server session that
      // belonged to the discarded draft.
      clearWizardUuid()
    }
  }

  function handleOpenDraft(_payload, nextDraft) {
    if (isWizardEnabled && nextDraft?.uuid) {
      // Re-stamp the server-uuid storage so `useWizardLifecycle` picks up
      // the right session when the wizard form mounts.
      saveWizardUuid(nextDraft.uuid)
    }
  }

  const minimizeKey = isWizardEnabled
    ? MINIMIZED_MODAL_KEY.REQUEST_WIZARD_FORM
    : MINIMIZED_MODAL_KEY.REQUEST_FORM

  return {
    draft,
    draftId,
    handleCreateNew,
    handleOpenDraft,
    minimizeKey,
    setDraft,
  }
}
